import { render } from "./UploadDocument.vue?vue&type=template&id=94b34874&ts=true"
import script from "./UploadDocument.vue?vue&type=script&lang=ts"
export * from "./UploadDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__